import React from 'react'
import bg_img from '../images/wp4102995.jpg'
import song from "../images/song.png"
import '../css/DisplayController.css'
import LinearProgress from '@mui/material/LinearProgress';
export default function DisplayController({menu,screen}) {
    return generateDisplayContent(menu,screen)
}

function generateDisplayContent(menu,screen){
    if(screen === "0"){
        var active = {"1":"","2":"","3":"","4":""}
        active[menu]="active";
        return (
            <div className="displayController">
                <div id="sideMenu">
                    <h6>iPod.js</h6>
                    <div className={active["1"]}>Cover Flow</div>
                    <div className={active["2"]}>Music</div>
                    <div className={active["3"]}>Games</div>
                    <div className={active["4"]}>Settings</div>
                </div>
                <div id="bgImg">
                    <img src={bg_img} alt="bg_img"></img>
                </div>
            </div>
        )
    }else if(screen === "1"){
        return(
            <div className="middle">COVER FLOW</div>
        )
    }else if(screen === "2"){
        return(
            <div className="musicPlayer">
                <div id="songTopSection">
                    <div id="imageSection">
                        <img src={song} alt="song"></img>
                    </div>
                    <div id="songDetails">
                        <h6>Locked Out of Heaven</h6>
                        <br></br>
                        <p>Bruno Mars</p>
                    </div>
                </div>
                <div id="songBottomSection">
                    <LinearProgress variant="determinate" value={20} />
                    <div id="songRunTime">
                        <span>1:26</span>
                        <span>3:53</span>
                    </div>
                </div>
            </div>
        )
    }else if(screen === "3"){
        return(
            <div className="middle">GAMES</div>
        )
    }else if(screen === "4"){
        return(
            <div className="middle">SETTINGS</div>
        )
    }else{
        return(
            <div className="middle">OPPS SOMETHING WENT WRONG!</div>
        )
    }
}
